export const UPDATE_SEARCHLIST = 'trainingCategorySearch/updateResults'
export const RESET_FILTERS = 'trainingCategorySearch/reset'
export const RESET_RESULTS = 'trainingCategorySearch/resetTableData'
export const UPDATE_CONTROL_NO = 'trainingCategoryAdd/getControlNo'
export const GET_DETAIL = 'trainingCategory/getDetails'
export const SET_CONFIRM_MODAL = 'trainingCategorySearch/setConfirmModal'
export const HIDE_CONFIRM_MODAL = 'trainingCategorySearch/hideConfirmModal'
export const SHOW_CONFIRM_MODAL = 'trainingCategorySearch/showConfirmModal'

// SEARCH FILTER TYPES
export const APPLY_FILTERS = 'trainingCategorySearch/applySearchFilter'
export const CHG_FILTER_DATA = 'trainingCategorySearch/changeFilterField'
export const CHG_FILTER_PAGE = 'trainingCategorySearch/changePage'
export const CHG_FILTER_PAGE_SIZE = 'trainingCategorySearch/changePageSize'
export const CHG_FILTER_SORT = 'trainingCategorySearch/changeSortModel'
export const IS_LOADING = 'trainingCategorySearch/isLoading'
export const CHG_SELECTED_ROWS = 'trainingCategorySearch/changeSelected'
export const HIDE_LIST_ALERT = 'trainingCategorySearch/hideAlert'
export const SET_LIST_ALERT = 'trainingCategorySearch/setAlertModal'

// ADD FORM TYPES
export const CHG_FIELD = 'trainingCategoryAdd/changeField'
export const CHG_STATUS = 'trainingCategoryAdd/changeStatus'
export const CHG_EMPLOYEE_ID = 'trainingCategoryAdd/changeEmployeeId'
export const CHG_INCOME_ID = 'trainingCategoryAdd/changeIncomeId'
export const CHG_AMOUNT = 'trainingCategoryAdd/changeAmount'
export const CHG_EFFECTIVE_DATE = 'trainingCategoryAdd/changeEffectiveData'
export const CHG_MEMO = 'trainingCategoryAdd/changememo'
export const RESET_ADD_DATA = 'trainingCategoryAdd/reset'
export const UPD_ADD_ALERT = 'trainingCategoryAdd/updateAlert'
export const HIDE_ADD_ALERT = 'trainingCategoryAdd/hideAlert'
export const UPD_ADD_MEMO_CHAR_COUNT = 'trainingCategoryAdd/updateMemoCharCount'
export const INSERT_LOADING = 'trainingCategoryAdd/isLoading'
export const SET_ADD_DATA = 'trainingCategoryAdd/setAddData'
export const CHANGE_UPDATE_VALUES = 'trainingCategoryAdd/changeUpdateValues'
export const FETCH_TRAINING_CATEGORY_VALUES = 'trainingCategoryAdd/fetchTrainingCategoryValues'

// DETAIL FORM TYPES
export const UPD_DETAIL_TITLE = 'trainingCategoryDetail/changeTitle'
export const RESET_DETAIL_DATA = 'trainingCategoryDetail/reset'
export const CHG_DETAIL_DATA = 'trainingCategoryDetail/changeFieldData'
export const UPD_DETAIL_MODE = 'trainingCategoryDetail/changeMode'
export const HAS_DETAIL_LOADED = 'trainingCategoryDetail/hasDetailLoaded'
export const SET_DETAIL_DATA = 'trainingCategoryDetail/setDetailData'
export const UPD_AMOUNT = 'trainingCategoryDetail/changeAmount'
export const UPD_DETAIL_MEMO_CHAR_COUNT = 'trainingCategoryDetail/updateMemoCharCount'
export const UPD_DETAIL_DATA = 'trainingCategoryDetail/updateDetailData'
export const SET_DETAIL_CONFIRM_MODAL = 'trainingCategoryDetail/setConfirmModal'
export const HIDE_DETAIL_CONFIRM_MODAL = 'trainingCategoryDetail/hideConfirmModal'
export const SHOW_DETAIL_CONFIRM_MODAL = 'trainingCategoryDetail/showConfirmModal'
export const SET_DETAIL_ALERT = 'trainingCategoryDetail/setAlertModal'
export const HIDE_DETAIL_ALERT = 'trainingCategoryDetail/hideAlert'


